import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Box } from '@mui/material';
import React, { useState } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


function BlogEditor({ handleEditorChange }: any) {
    const [editorContent, setEditorContent] = useState('');

    // const handleEditorChange = (event: any, editor: any) => {
    //     setEditorContent(editor.getData());
    // };

    return (
        <CKEditor
            onChange={handleEditorChange}
            data={editorContent}
            editor={ClassicEditor}
            config={{
                toolbar: {
                    items: [
                        'undo', 'redo', '|', 'heading', '|', 'bold', 'italic', '|',
                        'link', 'imageUpload', 'blockQuote', 'insertTable', 'mediaEmbed', '|',
                        'bulletedList', 'numberedList'
                    ],
                },
                image: {
                    toolbar: [
                        'imageUpload', 'imageTextAlternative', 'imageStyle:full', 'imageStyle:side'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells'
                    ]
                },
            }}
        />
    );
}

export default BlogEditor;
